/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PermissionlessTransformerDeployer,
  PermissionlessTransformerDeployerInterface,
} from "../PermissionlessTransformerDeployer";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "deployedAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Deployed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "bytecode",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
    ],
    name: "deploy",
    outputs: [
      {
        internalType: "address",
        name: "deployedAddress",
        type: "address",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "isDelegateCallSafe",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "toDeploymentSalt",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "toInitCodeHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b506112d5806100206000396000f3fe60806040526004361061003f5760003560e01c80634af63f02146100445780635d42a5f2146100745780638cd09f0c146100b1578063d253c0d7146100ee575b600080fd5b61005e6004803603810190610059919061102a565b61012b565b60405161006b91906110ef565b60405180910390f35b34801561008057600080fd5b5061009b60048036038101906100969190610fec565b61057f565b6040516100a89190611162565b60405180910390f35b3480156100bd57600080fd5b506100d860048036038101906100d39190610fec565b610597565b6040516100e5919061114f565b60405180910390f35b3480156100fa57600080fd5b5061011560048036038101906101109190610fec565b610fd1565b6040516101229190611162565b60405180910390f35b60006101597f5ebe86f29d528fb077b516f72ac7f75cca75a129d7e6eb87bbb513c2c4a7cac060001b610fe9565b6101857f5dba3c5c1e28de982d6c7a0ff32ccffc303969394f0d5821d757d86a1883250360001b610fe9565b8183516020850134f590506101bc7f984929a3da5bc6505375714365f4f2de5d0a31f89687a4c6ef793eb8188dade560001b610fe9565b6101e87f4c30c0896771f4aa7156dba17005f36d7519faa76a480b27775e2726daa1810160001b610fe9565b6102147f8c9abb74818cafdb0be4ecbb31ca0d5c4e6629c61d6e7779b858ff2b2632f20460001b610fe9565b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff161415610284576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161027b906111d7565b60405180910390fd5b6102b07fcf79c50b798359365ae9898bf5d8a593166faab206a91239caa4fce828737ecd60001b610fe9565b6102dc7f82282cb2bd328461d21a3e4b416739d271798a565a8886a3b1503342277413eb60001b610fe9565b6103087fae5cb28c5c2f9ce8f29968d8bfa136125706f89dccad7b582f4dae176c06a39960001b610fe9565b6103347fa572e78681196ad0ac9ebc9cdfaa5fc4b76f732272df9550ec9b7db2a1ca14bc60001b610fe9565b61033d81610597565b61037c576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161037390611173565b60405180910390fd5b6103a87fc1b9a0ab325d8a864542a8af06f0c0d0210795337adc5675be5c30e03097f4eb60001b610fe9565b6103d47f0ffb474441e512a9633fd14cde66740f6f1a61ab93480ef18f90980793631a1b60001b610fe9565b6104007fb89fca3fe75cbd03cd34938d008774372ed93ea655cc211c1693a81c76e6c81b60001b610fe9565b816000808373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555061046f7f388d225f9439b1d70fe8736be791cd5ec87164196077bd69f6251b62802e308560001b610fe9565b61049b7f410a2664ee301182b91a8fa0e20ae1a5add15ee4df3ea190930fbde6e46afa1b60001b610fe9565b8280519060200120600160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506105127fbae81c1d72044de795b2bfab49aff0f120dded541cf00d3b88f386188c472ecf60001b610fe9565b61053e7fc56c9794eaee16da28dbf2c9c7dc8a0e2d5cb580645cbafa0aa21bdc60806e9860001b610fe9565b7ffa86dcef4390d6a0f7edde563410fc44e4c2d382b4c6699cce5ebc4071abcc9581833360405161057193929190611116565b60405180910390a192915050565b60006020528060005260406000206000915090505481565b60006105c57f07b2bc1349429e59e43603042a0c088881713a8561519d03cde750aa37c27ece60001b610fe9565b6105f17f64232d43197b293017630446a42cb3c495e47aabe4e732efffc7e2e52e8be97a60001b610fe9565b61061d7f06bc5766eb41ae8337b0388811ff9e5a9c5ca7fcbd7b164a50552f848881964360001b610fe9565b600061064b7f155c28ff3debf88340a9914beb5c52f8dff45c521833c193bdfe992881d518b260001b610fe9565b823b905061067b7facc1166aa64fd33dce263b10fd67bb033b3ae7975ea9f92a213f0d89e7b0ca6e60001b610fe9565b6106a77fea8b1725ae155ed35ecd4ba9aac8a943fbe50ed872f89c03f8d5a6531e90121d60001b610fe9565b6106d37fe92363d80fe6e227b7bfe3ecc4ba81774096869917f5bf1c6a8869574f4ba3db60001b610fe9565b60008111610716576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161070d9061123b565b60405180910390fd5b6107427f9a7a8d02beb159af6d0b851ccbb41e68a3439f27bbd11df3dbe0518086f4b7bd60001b610fe9565b61076e7fbd7ddec1c30ddd760eaac20ba6918df3d5471a8a444983a86600b540cb7e3d0360001b610fe9565b61079a7fe395bae4a5260f12b70817ae614638acfaae1d20639c6f3e7a942bb6a936d87060001b610fe9565b60608167ffffffffffffffff811180156107b357600080fd5b506040519080825280601f01601f1916602001820160405280156107e65781602001600182028036833780820191505090505b5090506108157fd45f3f66c6b62147e8fbd0b11633e21f3d05cc450c6cfbba1c24427ee2b0942660001b610fe9565b81600060208301863c61084a7fadf9f272ecb570acf5d92c497363b38756543ea074be4387ee7584af48e65a8760001b610fe9565b6108767faa8e7282747bbc10bd73b75f255fdba05fdfa0adfb8c422af3b2f757b07eb12060001b610fe9565b6000600190506108a87f7cb2524ea920580a0034113e592c5e37adb895cec4aaf252f32e0fa7250dc17d60001b610fe9565b6108d47fb9d535706713b42148cc09be756af0c810abc211a94c9208906197b11391931f60001b610fe9565b60005b8251811015610f6b5761090c7f14bc6683a0c1d5a41937e7105af6affb900a24d8c27719d33750e008786759e260001b610fe9565b6109387fb1215130e156f0eb41e2254cc95145346ec97cae20315d2b36bc42ac6f75d1c560001b610fe9565b600083828151811061094657fe5b602001015160f81c60f81b60f81c90506109827f93958734acc668fe38c9370a588de66ab48f4b73b5e7c92f2984329066b6a5e860001b610fe9565b6109ae7f39de3d6d05f6e261af98bac890941d52811176602f554bfd7dbd012b7c3016d460001b610fe9565b605f8160ff161180156109c4575060808160ff16105b15610a8a576109f57f26eec786e060b158ecd8a02169696abf121ca178f1ee61002457db8e2b3cb6c160001b610fe9565b610a217f1b184900c1834ddcef72c39fa0235009ddf55a238786d77c749166793949cabf60001b610fe9565b610a4d7fc33f159412d22756c8afd1f581bb1a96700ac5de0005ad3b23af26700604a0c660001b610fe9565b605f810360ff1682019150610a847f2d7c6afce64813594a7868662a49d8e2eaab761d0a87a1de71de5973d081691d60001b610fe9565b50610f5e565b610ab67f7d65b6073d3c7c2a48e1634bb49b8e670f6f329c2898435a07a416ee4e7a324160001b610fe9565b610ae27f377c58d49927e97f57a253ccc26543c46d69699e57f56364f81171c11c9943db60001b610fe9565b610b0e7fad17d04dc140d39f079c75645bdd68317f3fe8dd219dc4671204cbe1e135eb3b60001b610fe9565b8215610e3d57610b407f51dad8bae3860fb73aac6fa72e9f036772e3bd195a84a3ad3aab8311be9688a260001b610fe9565b610b6c7fe1c606ef4add38ab93fb032bef829a69da05dfe820ecb194698dc1c402cae73960001b610fe9565b610b987fd009e4aaf757b37468335c9f555f9429cc9112d6c6e54572f5dc2927cd7a818e60001b610fe9565b60fe8160ff161480610bad575060f38160ff16145b80610bbb575060fd8160ff16145b80610bc9575060568160ff16145b80610bd7575060008160ff16145b15610c9657610c087f017de0d3b2fc7420dba477ef6c379178528ba5eba57871fb56cf630f90aff0ad60001b610fe9565b610c347f18d66133bf161eed2ad0a72150380ea9a5cb5a6f013ed0d01e88fd1646b3002560001b610fe9565b610c607f55fc3f0a83f8e7daca43199d58491843adc39d626051eb5b1b57ad945cde056060001b610fe9565b60009250610c907f6deb4274b838af1ab1578c3420cab5cdab84609a9642ec6955faee07b685f51460001b610fe9565b50610f5e565b610cc27f2c216f055a0f53d9ecb01f343609467b96ca8b747f65eabd7904a9fa50b0440860001b610fe9565b610cee7f933ae0c5c9998019146619607cb1718de2a12ea4ded5430a9e2bf463af38ce6560001b610fe9565b610d1a7f40b65a38e327d4c1e123e37056f79e6530144b85ea8307d61dfbf253726abc5460001b610fe9565b60f28160ff161480610d2f575060f48160ff16145b80610d3d575060ff8160ff16145b80610d4b575060f08160ff16145b80610d59575060f58160ff16145b80610d67575060548160ff16145b80610d75575060558160ff16145b15610e0c57610da67f695d6c37c874a837f10e6fb2868f99a243b7c94575783b90588e6e1c3862862260001b610fe9565b610dd27f0fe312b5b95d0de945b3eca64caa62bb739c8daa089467087fd2f51378b5728660001b610fe9565b610dfe7fb90615854c92055501fbe8dfe534369f76954e5c84396826aa4afe3ea210d0e460001b610fe9565b600095505050505050610fcc565b610e387f57c81d404ab5ac5a2c9fc8b3367b45b7e25764fe5dec04eb9978ba639e7353d660001b610fe9565b610f5c565b610e697f96d1566350054ec02912605ef2d5bb40cb494e36dab391be0f359eeb4eb4c8cb60001b610fe9565b610e957f413cc48558bc212e1d44a9286bb93506c93fa14307b367a59b7d0e6fa6f1032b60001b610fe9565b605b8160ff161415610f2e57610ecd7fba9cab8b3c8d50c34e44468f30ccde5774e7e3044c212ef93523d3fa0cdb4be260001b610fe9565b610ef97f8e36625e90cff7bb096b59c943ca6f878fdeef6ccc8561a97cc9ad40e5a5600360001b610fe9565b610f257f59b98c8e2f994f4bde84e49c7e1a03b10f6adebd0dde34570e8ccad337c83f0860001b610fe9565b60019250610f5b565b610f5a7fde5cc9b9bc5655373e0cae1e2aaf6a2cbbc42fee75a4a22404fa8a50a4568a1760001b610fe9565b5b5b505b80806001019150506108d7565b50610f987f3496968c9250b42e6177a0bcde6e203a2f1801dcab313f134c49f17f67fdc49d60001b610fe9565b610fc47fb5fcea6b9505fc189f07a600be816372e360ebf68263e211a93cdbc547f09c4060001b610fe9565b600193505050505b919050565b60016020528060005260406000206000915090505481565b50565b600060208284031215610ffd578081fd5b813573ffffffffffffffffffffffffffffffffffffffff81168114611020578182fd5b8091505092915050565b6000806040838503121561103c578081fd5b823567ffffffffffffffff80821115611053578283fd5b818501915085601f830112611066578283fd5b813581811115611074578384fd5b6040516020807fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f85011683010182811085821117156110b3578687fd5b806040525082825288818487010111156110cb578586fd5b82818601828401378581848401015281965080880135955050505050509250929050565b600060208201905073ffffffffffffffffffffffffffffffffffffffff8316825292915050565b600060608201905073ffffffffffffffffffffffffffffffffffffffff8086168352846020840152808416604084015250949350505050565b6000602082019050821515825292915050565b600060208201905082825292915050565b600060208252602d60208301527f5065726d697373696f6e6c6573735472616e73666f726d65724465706c6f796560408301527f722f554e534146455f434f4445000000000000000000000000000000000000006060830152608082019050919050565b600060208252602f60208301527f5065726d697373696f6e6c6573735472616e73666f726d65724465706c6f796560408301527f722f4445504c4f595f4641494c454400000000000000000000000000000000006060830152608082019050919050565b600060208252602960208301527f5065726d697373696f6e6c6573735472616e73666f726d65724465706c6f796560408301527f722f4e4f5f434f44450000000000000000000000000000000000000000000000606083015260808201905091905056fea26469706673582212208f9a36f0a4f64f985d11d896bd0560d3f7099c85b13abb892afc1b62fac704e064736f6c634300060c0033";

export class PermissionlessTransformerDeployer__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PermissionlessTransformerDeployer> {
    return super.deploy(
      overrides || {}
    ) as Promise<PermissionlessTransformerDeployer>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): PermissionlessTransformerDeployer {
    return super.attach(address) as PermissionlessTransformerDeployer;
  }
  connect(signer: Signer): PermissionlessTransformerDeployer__factory {
    return super.connect(signer) as PermissionlessTransformerDeployer__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PermissionlessTransformerDeployerInterface {
    return new utils.Interface(
      _abi
    ) as PermissionlessTransformerDeployerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PermissionlessTransformerDeployer {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PermissionlessTransformerDeployer;
  }
}
